import storage from './storage';

function authHeaders() {
  const user = storage.getUserInfo();
  const token = storage.getToken();
  if (user && token) {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
}

export default authHeaders;
